import { useContextState } from "../../../../hooks/theme"


const useStepStyles = () => {
  const { colors } = useContextState()

  return {
    usersAddedComtainer: {
      width: '100%',
      display: 'flex',
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      rowGap: '20px',
      height: '300px'
    },
    viewMore: {
      fontSize: '1rem',
      color: colors.color16,
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    areaTitle: {
      fontSize:'12px',
      color: colors.color10,
      display:'flex',
      alignItems: 'center',
    },
    title: {
      fontSize: '1.2rem',
      '& span': {
        color: colors.color4
      }
    },
    description: {
      fontSize: '1rem',
    },
    information: {
      width: '100%',
      display: 'flex',
      alignItems: "center",
      flexDirection: "column",
    },
  }
}

export { useStepStyles }
